import { React, useState } from 'react';
import NavbarDefault from "../components/navbarDefault";
import FooterDefault from "../components/footerDefault";
import Button from '@mui/material/Button';
import { Grid, Input, Typography } from '@mui/material';
import { Document, Page, pdfjs} from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import "react-pdf"

import { createTheme, responsiveFontSizes } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

var tabs = [
    {
        title : "DCSFacilities",
        button_title : "FACILITIES",
        pdf : "/DCS Facilities.pdf",
        header : "DCS FACILITIES"
    },
    {
        title : "AppForm",
        button_title : "FACILITIES FORM",
        pdf : "/DCS Facilities Form.pdf",
        header : "DCS FACILITIES APPLICATION FORM"
    },
    {
        title : "Request",
        button_title : "ROOM USE",
        pdf : "/Request for Facilities or Room Use.pdf",
        header :'REQUEST FOR FACILITIES OR ROOM USE'
    },
    {
        title :"EducTour",
        button_title : "TOUR",
        pdf : "/Citizen's Charter Handbook - Tour.pdf",
        header: "REQUEST FORM FOR EDUCATIONAL TOUR/FIELD TRIP/BENCHMARKING"
    }
]

    

const Calendar = () => {
    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [currentTab, setCurrentTab] = useState("DCSFacilities")
    const [downloadPath, setDownloadPath] = useState("/DCS Facilities.pdf")
    const [pageScale, setPageScale] = useState(1)

    const pageOffset = (e) => {
        const regex = /^[0-9\b]+$/;
        if (!isNaN(+e.target.value) || regex.test(e.target.value)){
            if (parseInt(e.target.value) <= numPages && parseInt(e.target.value) > 0){
                setCurrentPage(parseInt(e.target.value));
                setPageNumber(parseInt(e.target.value));
            }
        } 
    }

    function handleTab(selectedTab){
        setCurrentTab(selectedTab.title);
        setDownloadPath(selectedTab.pdf);
    }

    function onDocumentSuccess({numPages}){
        setNumPages(numPages);
        setPageNumber(1);
        setCurrentPage(1);
        setPageScale(1);
    }

    function handleNext() {
        if (pageNumber < numPages) {
          setPageNumber(pageNumber + 1);
          setCurrentPage(currentPage + 1);
        }
    }

    function handlePrevious() {
        if (pageNumber > 0) {
            setPageNumber(pageNumber - 1);
            setCurrentPage(currentPage - 1);
        }
    }

    function zoomIn() {
        if (pageScale < 3.2){
            setPageScale(pageScale+0.7);
        }
    }

    function zoomOut(){
        if (pageScale > 1){
            setPageScale(pageScale-0.7);
        }
    }

    return(
        <ThemeProvider theme={theme}>
        <NavbarDefault />
            <Grid         
                container
                direction="row"
                justifyContent="center"
                height="50%"
                sx={{ flexGrow: 1, 
                paddingBottom: 2,
                paddingRight: 2,
                marginTop: 2,
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: 5,
                maxWidth: 1,
                alignItems: "center"
                }}
                spacing={2}
            >
                <Grid item xs={8} sx={{textAlign: 'justify'}}>
                    {tabs.map((tab) => (
                        <Typography hidden={tab.title !== currentTab} variant='h4' fontFamily="Segoe UI" fontWeight={700} marginBottom={4}>
                            {tab.header}
                        </Typography>
                    ))}
                </Grid>

                <Grid item xs={8} sx={{textAlign: 'justify'}}>
                    {tabs.map((tab) => (
                        <Button variant="contained" size="large" style={{fontFamily: "Segoe UI"}} sx={{ marginRight: 1, ":hover": { bgcolor: "#5A0C0E", color:"white", fontFamily: 'Segoe UI'}, bgcolor:"#223730"}} onClick={e => {handleTab(tab)}}>
                            {tab.button_title}
                        </Button>
                    ))}
                </Grid>

                <Grid item xs={8} sx={{alignItems: 'center'}}>
                    <Input value={currentPage}
                    textAlign = 'center'
                    sx = {{width: '30px'}}
                     onChange={(e) => {
                        if (e.target.value === "") {
                            setCurrentPage(e.target.value);
                        } else {
                            pageOffset(e);                            
                        }
                    }}
                    >
                    
                    </Input>
                    / {numPages || "--"}
                    <Button type="button" disabled={pageNumber <= 1} onClick={handlePrevious} variant="contained" size="large" style={{fontFamily: "Cabin"}} sx={{":hover": {bgcolor: "#5A0C0E", color:"white"}, marginLeft:2, marginRight:2 , bgcolor:"#223730"}}>
                        Previous
                    </Button>
                    <Button type="button" disabled={pageNumber >= numPages} onClick={handleNext} variant="contained" size="large" style={{fontFamily: "Cabin"}} sx={{":hover": {bgcolor: "#5A0C0E", color:"white" }, bgcolor:"#223730"}}>
                        Next
                    </Button>
                    <Button type="button" disabled={pageScale < 1} onClick={zoomOut} variant="contained" size="large" style={{fontFamily: "Cabin"}} sx={{":hover": {bgcolor: "#5A0C0E", color:"white"}, marginLeft:2, marginRight:2 , bgcolor:"#223730"}}>
                        -
                    </Button>
                    <Button type="button" disabled={pageScale > 3.1} onClick={zoomIn} variant="contained" size="large" style={{fontFamily: "Cabin"}} sx={{":hover": {bgcolor: "#5A0C0E", color:"white"}, marginLeft:0, marginRight:1 , bgcolor:"#223730"}}>
                        +
                    </Button>
                    <a href={downloadPath} download style={{ textDecoration: 'none'}}>
                        <Button type="button" disabled={pageScale == 3.1} onClick={zoomIn} variant="contained" size="large" style={{fontFamily: "Cabin"}} sx={{":hover": {bgcolor: "#5A0C0E", color:"white"}, marginLeft:1, marginRight:1 , bgcolor:"#223730"}}>
                            Download
                        </Button>
                    </a>

                </Grid>
            </Grid>
            <Grid marginBottom = {0} sx={{textAlign: 'justify', height: '100vh', width:1, display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: 0}}>
                <Grid item sx={{margin: '20px', width: "60%", height: '90vh', overflowY: 'scroll', boxShadow: '0 25px 50px 0 rgba (62, 62, 62, 0.15)', WebkitBoxShadow: '0 25px 50px 0 rgb(62 62 62 / 15%)'}}>
                    {tabs.map((tab) => (tab.title === currentTab ? 
                    <Document file={tab.pdf} onLoadSuccess={onDocumentSuccess} onContextMenu={(e) => e.preventDefault()}>
                        <Page align='center' scale={pageScale} pageNumber={pageNumber} style={{width:1}} renderMode='svg' renderTextLayer={false}/>
                    </Document> : null
                    ))}
                </Grid>
            </Grid>
        <FooterDefault /> 
        </ThemeProvider>
    )
}

export default Calendar